__turbopack_context__.v({
  "file-item": "GQNHqq_file-item",
  "file-item__delete": "GQNHqq_file-item__delete",
  "file-item__name": "GQNHqq_file-item__name",
  "file-item__size": "GQNHqq_file-item__size",
  "file-list": "GQNHqq_file-list",
  "file-upload": "GQNHqq_file-upload",
  "file-upload--dragging": "GQNHqq_file-upload--dragging",
  "file-upload--error": "GQNHqq_file-upload--error",
  "file-upload__description": "GQNHqq_file-upload__description",
  "file-upload__descriptions": "GQNHqq_file-upload__descriptions",
  "file-upload__heading": "GQNHqq_file-upload__heading",
});
